import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { fetchAdjustmentLogs } from '../../actions/project_actions';
import { NBSP, getFullName, milestoneToTitle, camelToTitle } from '../../utils';
import { getDateValue } from '../../utils/date';
import { NAMES } from './schedule_constants';

const PAGE_SIZE = 10;

class ScheduleHistory extends React.Component {
  // static PropTypes = {
  //   projectId: PropTypes.string.isRequired,
  //   adjustmentLogs: PropTypes.array.isRequired,
  //   divisionName: PropTypes.string.isRequired,
  //   fetchAdjustmentLogs: PropTypes.func.isRequired,
  // }

  constructor (props) {
    super(props);
    this.state = {
      page: 0,
      finished: false,
      isEmpty: false,
    }

    this.toTitle = (milestone) =>
      milestoneToTitle(milestone, props.divisionName);
  }

  UNSAFE_componentWillMount() {
    this.fetchPage(0);
  }

  UNSAFE_componentWillReceiveProps (nextProps) {
    const nextPageLength = nextProps.adjustmentLogs.length;
    const isEmpty = this.state.page === 0 && nextPageLength === 0;
    this.setState({
      finished: nextPageLength < PAGE_SIZE,
      isEmpty,
    });
  }

  fetchPage (page) {
    const params = {
      take: PAGE_SIZE,
      skip: page * PAGE_SIZE,
    }
    this.props.fetchAdjustmentLogs(this.props.projectId, params);
  }

  getPage (n) {
    const page = this.state.page + n;
    this.setState({ page });
    this.fetchPage(page);
  }

  renderRow ({ dateTime, logs }) {
    const changes = [];
    let lastComment = '';
    let lastName = '';

    const filteredLogs = logs.filter(log => log.milestoneType !== 'scheduleStage');

    filteredLogs.sort((prev, next) => {
      const prevIndex = NAMES.indexOf(prev.milestoneValueType);
      const nextIndex = NAMES.indexOf(next.milestoneValueType);
      return prevIndex - nextIndex;
    });

    filteredLogs.forEach(log => {
      if (!log.oldValue && !log.newValue) return;
      const name = log.milestoneValueType;

      changes.push({
        key: log.id,
        milestone: this.toTitle(log.milestoneType),
        name: lastName !== name ? camelToTitle(log.milestoneValueType) : NBSP,
        oldDate: log.oldValue ? getDateValue(log.oldValue) : 'None',
        newDate: log.newValue ? getDateValue(log.newValue) : 'None',
        comment: lastComment !== log.comment ? log.comment : NBSP,
      });

      lastName = name;
      lastComment = log.comment;
    });

    if (changes.length === 0 || !filteredLogs[0].createdUserId) return null;

    return (
      <tr key={dateTime}>
        <td>{getDateValue(dateTime)}</td>
        <td>{getFullName(logs[0].createdUser)}</td>
        <td>{changes.map(change => <div key={change.key}>{change.name}</div>)}</td>
        <td>{changes.map(change => <div key={change.key}>{change.milestone}</div>)}</td>
        <td>
          {changes.map(change =>
            <div key={change.key}>{change.oldDate}{' → '}{change.newDate}</div>
          )}
        </td>
        <td>{changes.map(change => <div key={change.key}>{change.comment}</div>)}</td>
      </tr>
    );
  }

  renderTable (adjustmentLogs) {
    return (
      <div className="table-wrap">
        <table>
          <thead>
            <tr>
              <th>When</th>
              <th>Who</th>
              <th>What</th>
              <th>Milestone</th>
              <th>Changes</th>
              <th>Reason</th>
            </tr>
          </thead>
          <tbody>
          { adjustmentLogs.map(adjustmentLog => this.renderRow(adjustmentLog)) }
          </tbody>
        </table>
      </div>
    );
  }

  renderEmpty () {
    return (
      <div className="col s12 schedule-history">
        This project does not have any Schedule History yet.
      </div>
    );
  }

  render () {
    const { page, finished, isEmpty } = this.state;
    const { adjustmentLogs } = this.props;

    if (isEmpty) return this.renderEmpty();
    if (adjustmentLogs.length === 0) return null;

    return (
      <div className="col s12 schedule-history">
        <div className="header">
          <h4>History</h4>
          { !finished ? <button onClick={() => this.getPage(1)}>Next</button> : null }
          { page > 0 ? <button onClick={() => this.getPage(-1)}>Previous</button> : null }
        </div>
        {this.renderTable(adjustmentLogs)}
      </div>
    )
  }
}

ScheduleHistory.propTypes = {
  projectId: PropTypes.string.isRequired,
  adjustmentLogs: PropTypes.array.isRequired,
  divisionName: PropTypes.string.isRequired,
  fetchAdjustmentLogs: PropTypes.func.isRequired
};

function mapStateToProps (state, ownProps) {
  return {
    projectId: ownProps.projectId,
    divisionName: state.projectsStore.divisionName,
    adjustmentLogs: state.projectsStore.adjustmentLogs,
  };
}

export default connect(mapStateToProps, {fetchAdjustmentLogs})(ScheduleHistory);